import _ from 'lodash'
import Voucherify from '../config/voucherify'

const { url, headers } = Voucherify.getVoucherConfig()

const convertToCent = value => {
  return Number(value * 100)
}

const getBodyMetadata = (order, newSubtotal, newGrandTotal) => {
  const { voucher } = order
  const { customer, metadata } = voucher

  const customerMetadata = {
    source_id: customer.source_id,
    name: customer.name
  }

  const isDiscountOnDeliveryFee = _.get(voucher, 'voucher.metadata.discount_on', 'order') === 'delivery-fee'

  const newGrandTotalInCent = convertToCent(newGrandTotal)
  const newSubtotalInCent = convertToCent(newSubtotal)
  const deliveryFeeInCent = metadata.delivery_fee

  const orderMetadata = {}
  orderMetadata.amount = isDiscountOnDeliveryFee ? deliveryFeeInCent : newGrandTotalInCent
  orderMetadata.status = 'CREATED'
  orderMetadata.customer = { id: customer.id || "" }

  const redemptionMetadata = {
    ...metadata,
    grand_total: newGrandTotalInCent,
    food_sub_total: newSubtotalInCent,
    order_amount: newSubtotalInCent,
    subtotal: newSubtotalInCent + metadata.delivery_fee
  }

  return {
    customer: customerMetadata,
    order: orderMetadata,
    metadata: redemptionMetadata,
  }
}

const validate = async (code, bodyMetadata) => {
  try {
    const endpoint = `${url}/v1/vouchers/${code.toLowerCase()}/validate`
    const res = await fetch(endpoint, { method: 'POST', headers, body: JSON.stringify(bodyMetadata) })

    if (res && res.status !== 200) throw res.status

    const response = await res.json()

    const valid = _.get(response, 'valid', false)

    let reason = null
    if (!valid) reason = _.get(response, 'error.message', 'Validate Failed')

    return {
      valid,
      reason,
    }
  } catch (error) {
    throw error
  }
}

const redeem = async (code, bodyMetadata) => {
  try {
    const endpoint = `${url}/v1/vouchers/${code.toLowerCase()}/redemption`

    const res = await fetch(endpoint, { method: 'POST', headers, body: JSON.stringify(bodyMetadata) })

    if (res && res.status !== 200) throw res.status

    const redemptionResult = await res.json()

    return redemptionResult
  } catch (error) {
    throw error
  }
}

const rollback = async (redemptionId, reason) => {
  try {
    const endpoint = `${url}/v1/redemptions/${redemptionId}/rollback?reason=${reason}`
    const res = await fetch(endpoint, { method: 'POST', headers })

    return res
  } catch (error) {
    throw error
  }
}

const reInvokeVoucher = async order => {
  try {
    const { voucher } = order
    const bodyMetadata = {
      customer: voucher.customerMetadata,
      order: voucher.orderMetadata,
      metadata: voucher.redemptionMetadata,
    }

    const { code } = voucher.voucher
    const endpoint = `${url}/v1/vouchers/${code.toLowerCase()}/redemption`

    const res = await fetch(endpoint, { method: 'POST', headers, body: JSON.stringify(bodyMetadata) })

    if (res && res.status !== 200) throw res.status

    const redemptionResult = await res.json()

    return redemptionResult
  } catch (error) {
    throw error
  }

}


export default {
  redeem,
  rollback,
  validate,
  getBodyMetadata,
  reInvokeVoucher,
}



// WEBPACK FOOTER //
// ./src/prototypes/voucherify.js